import {faTriangleExclamation} from '@fortawesome/pro-regular-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Text} from '@rdcomponents/text/text';
import {Space} from 'antd';
import {useCallback} from 'react';

import {Locale} from '../../../../../provider/locale/locale';
import {useModal} from '../../../../../provider/modal/modal-hook';
import {useDisconnectTelegramAccount} from '../../../../../service/notifications-settings/notifications-settings-hook';
import {TelegramAccountType} from '../../../../../service/notifications-settings/notifications-settings-type';

import * as styles from './deactivation-modal.scss';

export function useTelegramDisconnectModal(account: TelegramAccountType, refetch: () => void): () => void {
    const {modal} = useModal();
    const {mutateAsync, isLoading} = useDisconnectTelegramAccount();

    return useCallback(() => {
        return modal.confirm({
            icon: (
                <FontAwesomeIcon className={styles.DeactivationModal_icon} fontSize={24} icon={faTriangleExclamation} />
            ),
            okButtonProps: {
                danger: true,
                loading: isLoading,
            },
            title: <Locale stringKey="TELEGRAM__NOTIFICATIONS__ACCOUNT__DISCONNECT_MODAL__TITLE" />,
            content: (
                <Space direction="vertical">
                    <Locale stringKey="TELEGRAM__NOTIFICATIONS__ACCOUNT__DISCONNECT_MODAL__DESCRIPTION" />
                    <Text
                        className={styles.DeactivationModal_account}
                        secondary
                        stringKey="TELEGRAM__NOTIFICATIONS__ACCOUNT__DISCONNECT_MODAL__ACCOUNT"
                        valueMap={{account: <Text>{account.displayName}</Text>}}
                    />
                </Space>
            ),
            cancelText: <Locale stringKey="BUTTON__CANCEL" />,
            okText: <Locale stringKey="TELEGRAM__NOTIFICATIONS__ACCOUNT__ACTIONS__DISCONNECT" />,
            onOk: () => {
                mutateAsync(account.id)
                    .then(() => {
                        refetch();
                    })
                    .catch(() => {
                        console.error('failed to disconnect');
                    });
            },
        });
    }, [modal, isLoading, account, mutateAsync, refetch]);
}
